<template>
    <div class="roles">
        <div class="current-roles">
            <div v-for="role in currentRoles" class="role label bg-aqua">
                <span>{{ role.description }}</span> <a class="tiny redHover square" @click="dismissRole(role)">✖</a>
            </div>
            <a class="square" v-if="absentRoles.length" @click.prevent="showAvailable"  v-show="availableRolesCollapsed">Добавить роль</a>
        </div>
        <ul class="available-roles" v-show="!availableRolesCollapsed">
            <li class="role-list-item" v-for="role in absentRoles">
                <a @click="addRole(role)">
                    <span>{{ role.description }}</span>
                </a>
            </li>
        </ul>

    </div>
</template>

<script>

export default {
    props: {
        availableRoles: {
            type: Array,
            default: true,
        },
        currentRoles: {
            type: Array,
            required: true,
        }
    },
    model: {
        prop: 'currentRoles'
    },

    data () {
        return { availableRolesCollapsed: true}
    },
    computed: {
        absentRoles () {
            return this.availableRoles.filter((role) => {
                let exists = this.currentRoles.findIndex((elt) => {return elt.name === role.name});
                if (exists > -1) {
                    return false;
                }
                return true;
            })
        }
    },

    components: {
    },
    methods: {
        showAvailable () {
            this.availableRolesCollapsed = !!!this.availableRolesCollapsed;
        },
        addRole (role) {
            this.currentRoles.push(role);
            this.availableRolesCollapsed = true;
        },
        dismissRole (role) {
            let index = this.currentRoles.findIndex(r => r.name === role.name);
            if (index > -1) {
                this.currentRoles.splice(index, 1);
                this.$emit('change', this.currentRoles);
            }
        }
    }
}
</script>

<style lang="scss">
.roles {
    .role {
        display: inline-block;
        padding: 3px 5px;
        border-radius: 5px;
        font-size: 0.9em;

        margin-right:10px;

        a {
            text-decoration: none;
            border:none;
            color:white;

            &:hover {
                color: red;
            }
        }
    }
}
</style>